/*-- Inside specialities Images---*/
import cardimage1 from "../assets/images/Services/331.jpg";
import Cardimage2 from "../assets/images/Services/doctor-checking-patient.jpg";
import Neuroimage1 from "../assets/images/Services/2659.jpg";
import Neuroimage2 from "../assets/images/Services/713.jpg";
import Nsurgeryimage1 from "../assets/images/Services/595.jpg";
import Nsurgeryimage2 from "../assets/images/Services/129870.jpg";
import Oncologyimage1 from "../assets/images/Services/6435.jpg";
import Oncologyimage2 from "../assets/images/Services/24397.jpg";
import Generalimage1 from "../assets/images/Services/20392.jpg";
import generalimage2 from "../assets/images/Services/doctor-hand-writing-prescription-desk-close-up.jpg";
import Laprosopyimage1 from "../assets/images/Services/218.jpg";
import Laprosopyimage2 from "../assets/images/Services/12017.jpg";
import Pulmanologyimage1 from "../assets/images/Services/2152005917.jpg";
import Pulmanologyimage2 from "../assets/images/Services/89684.jpg";
import ENTimage1 from "../assets/images/Services/7734.jpg";
import ENTimage2 from "../assets/images/Services/18948.jpg";
import Nephrologyimage1 from "../assets/images/Services/2147718.jpg";
import Nephrologyimage2 from "../assets/images/Services/13457.jpg";
import Spineimage1 from "../assets/images/Services/11509.jpg";
import Spineimage2 from "../assets/images/Services/veterinarian-doctor-in-operation-room-for-laparosc-2026-01-09-11-04-31-utc.jpg";
import Plastic1 from "../assets/images/Services/206545.jpg";
import Plastic2 from "../assets/images/Services/2149349947.jpg";
import Gastroenterologyimage1 from "../assets/images/Services/18388.jpg";
import Gastroenterologyimage2 from "../assets/images/Services/425.jpg";
import surgicalGastroenterologyimage1 from "../assets/images/Services/13629.jpg";
import surgicalGastroenterologyimage2 from "../assets/images/Services/2148962499.jpg";
import Orthopedicsimage1 from "../assets/images/Services/62392.jpg";
import Orthopedicsimage2 from "../assets/images/Services/40497.jpg";
import Endocrinologyimage1 from "../assets/images/Services/6623.jpg";
import Endocrinologyimage2 from "../assets/images/Services/4164.jpg";
import arthroscopyimage1 from "../assets/images/Services/55738.jpg";
import arthroscopyimage2 from "../assets/images/Services/5346.jpg";
import PhysioTherapy1 from "../assets/images/Services/53078.jpg";
import PhysioTherapy2 from "../assets/images/Services/24208.jpg";
import Urologyimage1 from "../assets/images/Services/2149351652.jpg";
import Urologyimage2 from "../assets/images/Services/4101.jpg";
import Vascularimage1 from "../assets/images/Services/75858.jpg";
import Vascularimage2 from "../assets/images/Services/16793.jpg";
import rheumatologyimage1 from "../assets/images/Services/132051.jpg";
import rheumatologyimage2 from "../assets/images/Services/2148846563.jpg";
import gynecologyimage1 from "../assets/images/Services/9148.jpg";
import gynecologyimage2 from "../assets/images/Services/doctor-performing-ultrasound-scanning-her-pregnant-patient.jpg";
import pediatricsimage1 from "../assets/images/Services/9417.jpg";
import pediatricsimage2 from "../assets/images/Services/doctor-doing-their-work-pediatrics-office.jpg";
import Dentalimage1 from "../assets/images/Services/12475.jpg";
import Dentalimage2 from "../assets/images/Services/142460.jpg";
import Anaesthesiologyimage1 from "../assets/images/Services/4564.jpg";
import Anaesthesiologyimage2 from "../assets/images/Services/6607.jpg";
import CriticalCareimage1 from "../assets/images/Services/10768.jpg";
import CriticalCareimage2 from "../assets/images/Services/2148962526.jpg";
import emergencyimage1 from "../assets/images/Services/198737.jpg";
import emergencyimage2 from "../assets/images/Services/2151997621.jpg";
import dental1 from "../assets/images/Services/270354.jpg";
import dental2 from "../assets/images/Services/12475.jpg";
import pediatric1 from "../assets/images/Services/30529.jpg";
import pediatric2 from "../assets/images/Services/6848.jpg";
import sports1 from "../assets/images/Services/8520.jpg";
import sports2 from "../assets/images/Services/2148393916.jpg";
import pediatricsorthopedics1 from "../assets/images/Services/15063.jpg";
import pediatricsorthopedics2 from "../assets/images/Services/2148673974.jpg";

/*-- DesktopBanners---*/
import bannerCardio from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-01.jpg";
import bannerNeurology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-02.jpg";
import bannerneuroSurgery from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-03.jpg";
import bannerOncology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-04.jpg";
import bannerGastroenterology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-05.jpg";
import bannerBrain from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-06.jpg";
import bannersurgicalgastroenterology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-07.jpg";
import bannerOrthopedics from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-08.jpg";
import bannerArthroscopy from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-09.jpg";
import bannerUrology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-10.jpg";
import bannerPulmonology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-11.jpg";
import bannerVascular from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-12.jpg";
import bannerNephrology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-13.jpg";
import bannerRheumatology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-14.jpg";
import bannerENT from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-15.jpg";
import bannerGeneral from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-16.jpg";
import bannerLaparoscopy from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-17.jpg";
import bannerObstetrics from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-18.jpg";
import bannerPediatrics from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-19.jpg";
import bannerDental from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-20.jpg";
import bannerPlastic from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-21.jpg";
import bannerEndocrinology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-22.jpg";
import bannerAnaesthesiology from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-23.jpg";
import bannerCritical from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-24.jpg";
import bannerEmergency from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-25.jpg";
import bannerPhysio from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-26.jpg";
import bannerdental from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-28.jpg";
import bannersports from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-30.jpg";
import bannerpediatricsurgery from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-29.jpg";
import bannerPediatricortho from "../assets/images/Services/Service-desktop-Banners/All Specialities Page  headers-31.jpg";

/*-- MobileBanners---*/
import bannerCardio_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-01.jpg";
import bannerNeurology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-02.jpg";
import bannerneuroSurgery_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-03.jpg";
import bannerOncology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-04.jpg";
import bannerGastroenterology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-05.jpg";
import bannerBrain_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-06.jpg";
import bannersurgicalgastroenterology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-07.jpg";
import bannerOrthopedics_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-08.jpg";
import bannerArthroscopy_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-09.jpg";
import bannerUrology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-10.jpg";
import bannerPulmonology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-11.jpg";
import bannerVascular_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-12.jpg";
import bannerNephrology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-13.jpg";
import bannerRheumatology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-14.jpg";
import bannerENT_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-15.jpg";
import bannerGeneral_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-16.jpg";
import bannerLaparoscopy_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-17.jpg";
import bannerObstetrics_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-18.jpg";
import bannerPediatrics_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-19.jpg";
import bannerDental_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-20.jpg";
import bannerPlastic_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-21.jpg";
import bannerEndocrinology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-22.jpg";
import bannerAnaesthesiology_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-23.jpg";
import bannerCritical_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-24.jpg";
import bannerEmergency_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-25.jpg";
import bannerPhysio_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-26.jpg";
import bannersports_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-30.jpg";
import bannerpediatricsurgery_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-29.jpg";
import bannerPediatricortho_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-31.jpg";
import bannerdental_m from "../assets/images/Services/Service-desktop-Banners/All Specialities Headers MobileScreen-28.jpg";

/*-- Icons---*/
import cardiologyIcon from "../assets/icons/serviceIcon/heartbeat (1).png";
import NeurologyIcon from "../assets/icons/serviceIcon/brain.png";
import neuroIcon from "../assets/icons/serviceIcon/surgery.png";
import oncologyIcon from "../assets/icons/serviceIcon/oncology.png";
import GeneralIcon from "../assets/icons/serviceIcon/medicinal.png";
import LaparoscopyIcon from "../assets/icons/serviceIcon/laparoscopy.png";
import ENTIcon from "../assets/icons/serviceIcon/esophagus.png";
import pulmonologyIcon from "../assets/icons/serviceIcon/lungs.png";
import nephrologyIcon from "../assets/icons/serviceIcon/nephrology.png";
import spineIcon from "../assets/icons/serviceIcon/laminectomy.png";
import gastroenterologyIcon from "../assets/icons/serviceIcon/stomach.png";
import surgicalgastroenterologyIcon from "../assets/icons/serviceIcon/bariatric-surgery.png";
import orthopedicsIcon from "../assets/icons/serviceIcon/shin.png";
import arthroscopyIcon from "../assets/icons/serviceIcon/reflex.png";
import PhysioIcon from "../assets/icons/serviceIcon/physio.png";
import urologyIcon from "../assets/icons/serviceIcon/urology.png";
import vascularIcon from "../assets/icons/serviceIcon/vascular-surgery.png";
import RheumatologyIcon from "../assets/icons/serviceIcon/joints.png";
import obstetricsIcon from "../assets/icons/serviceIcon/ultrasound.png";
import pediatricsIcon from "../assets/icons/serviceIcon/pediatrics.png";
import DentalIcon from "../assets/icons/serviceIcon/dental-health.png";
import anaesthesiologyIcon from "../assets/icons/serviceIcon/injection.png";
import CriticalCareIcon from "../assets/icons/serviceIcon/treatment.png";
import emergencyIcon from "../assets/icons/serviceIcon/first-aid-kit.png";
import PlasticSurgeryIcon from "../assets/icons/serviceIcon/face-marking.png";
import EndocrinologyIcon from "../assets/icons/serviceIcon/thyroid.png";
import MaxiIcon from "../assets/icons/serviceIcon/jaw-contouring.png";
import sportsIcon from "../assets/icons/serviceIcon/medical-kit.png";
import pediorthoIcon from "../assets/icons/serviceIcon/orthopedist.png";
import pedisurgeryIcon from "../assets/icons/serviceIcon/caesarean.png";

/*-- Speciality wise Doctors---*/
import Doctor1 from "../assets/images/Doctor.jpg";
import DEBARAJU from "../assets/images/Doctors/DR-E-DEBARAJU-REDDY.jpg";
import RAMKRISHNA from "../assets/images/Doctors/RAMKRISHNA.jpg";
import SYAMBABU from "../assets/images/Doctors/DR-SYAM-BABU-KATURI.jpg";
import BINDU from "../assets/images/Doctors/DR-BINDU-BHARGAVI-CH.jpg";
import CHETAN from "../assets/images/Doctors/DR-CHETAN-NARRA.jpg";
import RAMESH from "../assets/images/Doctors/DR-RAMESH-CHANDRA-VADAPALLI.jpg";
import ANUSHA from "../assets/images/Doctors/DR-ANUSHA-KANTHETI.jpg";
import SUNEEL from "../assets/images/Doctors/DR-SUNEEL-KUMAR-KOMMINENI.jpg";
import PURVA from "../assets/images/Doctors/DR-PURVA-ARTHAM.jpg";
import AMULYA from "../assets/images/Doctors/DR-AMULYA.jpg";
import PAVAN from "../assets/images/Doctors/Dr.Pavan_Kumar_Ediga.jpg";
import AVINASH from "../assets/images/Doctors/Dr.Avinash.jpg";
import SAMANVITHA from "../assets/images/Doctors/Dr.Samanvitha.jpg";
import MOUNIKA from "../assets/images/Doctors/Dr.Mounika.jpg";
import MOHIUDDIN from "../assets/images/Doctors/Dr.Mouiz.jpg";
import SHAMILI from "../assets/images/Doctors/Dr.Shamili.jpg";
import KALYAN from "../assets/images/Doctors/Dr.Kalyan.jpg";
// import VAMSHI from "../assets/images/Doctor.jpg";
// import MANISHANKAR from "../assets/images/Doctor.jpg";
// import SINDHUJA from '../assets/images/Doctors/DR-Y-L-SINDHUJA.jpg';

const SPECIALITIES = [
  {
    slug: "cardiology",
    title: "Cardiology & CTVS Surgery",
    icon: cardiologyIcon,
    shortdesc:
      "Prachin Global Hospitals Cardiology Department provides advanced, world-class cardiac care.",
    banner: bannerCardio,
    banner_m: bannerCardio_m,
    sections: {
      overview: `We have a centre of excellence in Cardiac Care, combined with a highly experienced team of Cardiologists and well trained Cardiology Technicians and Nursing Team place us at the forefront of Cardiac Care. Every treatment plan is tailored to ensure the best clinical outcomes, guiding each patient toward a healthier heart and a better quality of life. The Department of Cardiology at Prachin Global Hospitals is equipped with advanced AI Integrated Medical Technology and world class facility to deliver Quality Care. `,
      diagnosticsTitle: "Advanced Diagnostic Tools",
      diagnosticsDescription:
        "We offer comprehensive cardiac diagnostics including:",
      diagnostics: [
        "CT Coronary Angiogram",
        "Cardiac MRI",
        "Radionuclide Studies",
        "2D ECHO, TEE, DSE",
        "Holter Monitoring & ABPM ",
        "Tilt Table Test ",
      ],

      proceduresTitle: "Advanced Cathlab Services",
      proceduresDescription: `Our Hybrid & Neuro Cath Labs are equipped with:`,
      procedures: [
        "IVUS, OCT & NIRS-IVUS imaging ",
        "3D mapping systems ",
        "Advanced flat-panel imaging ",
      ],
      conditionstreatedtitle: "Cardiac Procedures",
      conditionstreateddesc: "We specialize in:",
      conditionstreatedpoints: [
        "Coronary & structural interventions ",
        "Complex angioplasty (CTO, bifurcation, Left Main) ",
        "Electrophysiology procedures ",
        "Peripheral vascular interventions ",
        "Post-bypass angioplasty ",
        "ECMO & Impella-supported cardiac care ",
      ],
      screeningTitle: "Preventive Cardiology",
      screeningContent: `We focus on early detection and prevention through:`,
      packages: [
        {
          title: "Heart health screening packages ",
        },
        {
          title: "Angiography packages ",
        },
        {
          title: "Regular cardiac risk assessments  ",
        },
      ],

      technologiesTitle: "Advanced Cardiac Surgery",
      technologies: [
        "Minimally invasive heart surgery ",
        "Robotic-assisted procedures ",
        "Complex cardiothoracic surgeries ",
      ],
      QuotationTitle: `Your heart deserves expert care — anytime, every time.`,
      images: [cardimage1, Cardimage2],
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "Dr. Arjun Reddy",
    //     dignity: "Senior Cardiologist",
    //     degree: "MD, DM (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },

  {
    slug: "neurology",
    title: "Neurology",
    icon: NeurologyIcon,
    shortdesc:
      "Neurophysiology Department provides advanced diagnostics for nervous system disorders.",
    banner: bannerNeurology,
    banner_m: bannerNeurology_m,
    sections: {
      overview: `Prachin Global Hospitals is equipped to treat conditions affecting the Brain, Spinal Cord, Nerves and Muscles with precision and care. Our team of highly experienced Neuro Physicians and Neurosurgeons brings together international standards, vast clinical experience and patient-first ethics to deliver world-class neurological care.`,

      diagnosticsTitle: "Advanced Neurology & Neurosurgery Care",
      diagnosticsDescription: `We offer a comprehensive range of non-invasive, minimally invasive and surgical treatments tailored to each patient’s condition. Our Neurology department infrastructure includes:`,
      diagnosticsSubHeading: "Advanced Neuro Care Facilities",
      diagnostics: [
        "HEPA-filtered modular operation theatres ",
        "Advanced Neuro ICUs with 24/7 monitoring ",
        "High-end MRI & CT imaging ",
        "Dedicated Neurophysiology & Rehabilitation units ",
        "Comprehensive outpatient & inpatient services ",
      ],
      proceduresTitle: "Comprehensive Neurological Diagnostics",
      proceduresDescription: `Our advanced Neuro Diagnostic services include:`,
      procedures: [
        "Electromyography (EMG) ",
        "Nerve Conduction Studies (NCS) ",
        "Electroencephalogram (EEG) ",
        "MRI & CT Scan ",
        "Advanced Neuro Lab Services ",
      ],
      conditionstreatedtitle: "Conditions We Treat",
      conditionstreatedpoints: [
        "Stroke ",
        "Epilepsy ",
        "Dementia & Alzheimer’s Disease ",
        "Parkinsonism ",
        "Multiple Sclerosis",
        "ALS (Amyotrophic Lateral Sclerosis) ",
        "Neuromuscular Disorders ",
        "Congenital Spine Disorders ",
        "Tourette’s Syndrome ",
      ],
      images: [Neuroimage1, Neuroimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. E PAVAN KUMAR",
         slug: "dr-e-pavan-kumar",
        dignity: "CONSULTANT NEUROSURGEON",
        degree: "MBBS, MS, MCh (NEURO SURGERY)",
        image: PAVAN,
      },
      {
        id: 2,
        name: "DR. SURESH BABU VALLEPU",
           slug: "dr-suresh-babu-vallepu",
        dignity: "CONSULTANT NEURO PHYSICIAN",
        degree: "MBBS, MD (GENERAL MEDICINE), DM (NEUROLOGY)",
        image: Doctor1,
      },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },

  {
    slug: "neuro-surgery",
    title: "Neurosurgery",
    icon: neuroIcon,
    shortdesc:
      "At Prachin Global Hospitals, the Department of Neurosurgery stands as a center of excellence.",
    banner: bannerneuroSurgery,
    banner_m: bannerneuroSurgery_m,
    sections: {
      overview: `At Prachin Global Hospitals, the Department of Neurosurgery stands as a Centre for Excellence, offering advanced and comprehensive care for patients with complex Neurological conditions. Our department of Neuro Surgery is led by highly experienced and dedicated Neuro Surgeons who provide round-the-clock services, ensuring timely and expert treatment for patients from across the region.`,

      moreoverview: `Prachin Global Hospitals delivers world-class Neuro Surgical care. The department performs a wide range of neuro surgical procedures, maintaining high standards of precision, safety, and patient outcomes.`,
      proceduresTitle: "Our Neurosurgery Services",
      procedures: [
        "Brain Tumor Surgery",
        "Spine & Spinal Cord Surgery",
        "Traumatic Brain & Spine Injury Management",
        "Minimally Invasive Neurosurgery",
        "Neuro-Critical Care",
        "Advanced Neuro Diagnostics & Treatment Planning",
        "Post-Surgical Rehabilitation & Supportive Care",
      ],
      proceduresNote: `At Prachin Global Hospitals, we combine advanced neuroscience with compassionate care to provide comprehensive neurological and neurosurgical treatment for patients of all ages.`,
      images: [Nsurgeryimage1, Nsurgeryimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. E PAVAN KUMAR",
         slug: "dr-e-pavan-kumar",
        dignity: "CONSULTANT NEUROSURGEON",
        degree: "MBBS, MS, MCh (NEURO SURGERY)",
        image: PAVAN,
      },
      // {
      //   id: 2,
      //   name: "Dr. Meera Sharma",
      //   dignity: "CTVS Specialist",
      //   degree: "MS, MCh (Cardiothoracic Surgery)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },

  {
    slug: "oncology",
    title: "Oncology",
    icon: oncologyIcon,
    shortdesc:
      "Prachin Global Hospitals Medical Oncology Department offers modern chemotherapy care.",
    banner: bannerOncology,
    banner_m: bannerOncology_m,
    sections: {
      overview:
        "Prachin Global Hospitals is a trusted destination for advanced cancer care in Hyderabad. Facilitate with dedicated and well-equipped cancer care centre, the hospital is committed to delivering world-class oncology services that focus not only on treatment but also on prevention, early diagnosis, rehabilitation and long-term survivorship.",
      moreoverview:
        "Our team of highly experienced cancer specialists—including Medical Oncologists, Surgical Oncologists—provides comprehensive and personalised cancer care. We firmly believe that treating cancer goes beyond medical intervention alone. Understanding the emotional, psychological  and social challenges faced by cancer patients and their families is central to our approach. Hence, we adopt a holistic care model that supports patients emotionally and mentally throughout their treatment journey. This integrated, multidisciplinary philosophy strengthens our commitment to excellence as leading cancer hospital in Hyderabad.",
      diagnosticsTitle:
        "Centre for Excellence in  Medical and Surgical Oncology",
      diagnosticsDescription: `The Department of Medical Oncology at Prachin Global Hospitals is equipped with modern day care Chemotherapy wards, oncology-trained nursing staff and an experienced doctors’ team. Cancer treatment planning is carried out through a multidisciplinary involving Medical Oncologists, Surgical Oncologists, Radiation Oncologists, Pathologists and Radiologists. This collaborative decision-making process ensures evidence-based, consensus-driven treatment plans that enhance treatment success.`,
      diagnosticssubtitle:
        "With rapid advancements in Oncology, including targeted therapy and immunotherapy, Prachin Global Hospitals stays at the forefront of innovation. ",
      diagnosticsSubHeading: "Our facilities include:",
      diagnostics: [
        "Outpatient Oncology Services",
        "Day Care and Inpatient Chemotherapy Units",
        "A Specialised Pediatric Oncology Ward",
        "One of the Largest In-House Bone Marrow Transplantation Units",
        "Advanced Chemotherapy Delivery Using Chemo Ports",
        "AI-Assisted Diagnosis, Analysis, and Personalised Treatment Planning",
      ],
      proceduresTitle: "Specialised Oncology Services",
      proceduresDescription: `Prachin Global Hospitals is home to a distinguished panel of oncologists specialising in a wide range of cancer disciplines:`,
      procedures: [
        "Head and Neck Oncology – Expert Diagnosis and Precision Treatment for Cancers Affecting the Oral Cavity, Throat, Larynx and Surrounding Regions",
        "Thoracic Oncology – Advanced Care for Lung and Chest-Related Cancers Using Cutting-Edge Therapeutic Technologies",
        "Orthopedic Oncology – Comprehensive Management of Bone and Soft Tissue Tumours with Both Surgical and Advanced Non-Surgical Techniques",
        "Gynaecological Oncology – Personalised and Compassionate Treatment for Cancers of the Female Reproductive System",
        "Nephrological & Urological Oncology – Specialised Care for Kidney, Bladder, Prostate and Other Urological Cancers to Ensure Complete Patient-Centred Treatment",
      ],
      proceduresNote:
        "Each specialty works in close collaboration to ensure accurate diagnosis, timely intervention and optimal clinical outcomes.",
      images: [Oncologyimage1, Oncologyimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. KALYAN VANGARA",
          slug: "dr-kalyan-vangara",
        dignity: "CONSULTANT SURGICAL ONCOLOGIST",
        degree:
          "MBBS, MS, MCh (SURGICAL ONCOLOGY), FMAS, FIAGES (Robotics & Laparoscopic Surgery)",
        image: KALYAN,
      },
      // {
      //   id: 2,
      //   name: "Dr. Meera Sharma",
      //   dignity: "CTVS Specialist",
      //   degree: "MS, MCh (Cardiothoracic Surgery)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "brain-and-spine-surgery",
    title: "Brain & Spine Surgery",
    icon: spineIcon,
    shortdesc:
      "Prachin Global Hospitals Spine Surgery Department offers advanced diagnostic and surgical care.",
    banner: bannerBrain,
    banner_m: bannerBrain_m,
    sections: {
      overview:
        "Prachin Global Hospitals is recognized as one of the best spine Hospitals in Hyderabad, offering comprehensive and evidence-based treatment for spinal disorders and injuries. Our expert team of Spine Surgeons and Orthopaedic spine specialists are highly experienced in advanced minimally invasive techniques, laser spine surgery and motion-preserving procedures to treat patients of all age groups.",
      moreoverview: `The Department of Spine Surgery at Prachin Global Hospitals is equipped with high end Diagnostic and Surgical facilities, including high-resolution digital X-rays, CT scans, MRI, EMG and Nerve Conduction Studies (NCS). We also offer advanced Robotic and Endoscopic Spine Surgery techniques to ensure precision, faster recovery and minimal post-operative discomfort.`,
      diagnosticsTitle:
        "We provide specialized treatment for a wide range of spinal conditions, including:",
      diagnostics: [
        "Herniated Disc (Slipped Disc)",
        "Degenerative Disc Disease (DDD)",
        "Cervical, Lumbar & Thoracic Spondylosis",
        "Spinal Stenosis & Sciatica",
        "Myelopathy (Cervical or Thoracic)",
        "Vertebral & Spinal Fractures",
        "Scoliosis, Kyphosis & Lordosis",
        "Ankylosing Spondylitis",
        "Spinal Infections & Spinal Osteomyelitis",
        "Tuberculosis of the Spine (Pott’s Disease)",
        "Spinal Cord Tumors & Metastatic Spine Cancer",
      ],
      diagnosticsDescription2: `Our expert Spine Surgeons specialized in procedures such as Spinal Fusion, Laminectomy and Discectomy, delivering patient-centric care focused on Pain Relief, Spinal Stability, Mobility Restoration and improved quality of life. With a multidisciplinary approach and advanced rehabilitation services, Prachin Global Hospitals ensures optimal recovery and long-term spine health for every patient.`,
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced surgical expertise with compassionate care to restore mobility, relieve pain and improve long-term neurological and spinal health.`,
      images: [Spineimage1, Spineimage2],
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "Dr. Arjun Reddy",
    //     dignity: "Senior Cardiologist",
    //     degree: "MD, DM (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },
  {
    slug: "gastroenterology",
    title: "Gastroenterology & Hepatology",
    banner: bannerGastroenterology,
    banner_m: bannerGastroenterology_m,
    icon: gastroenterologyIcon,
    shortdesc:
      "Prachin Global Hospitals Gastroenterology Department provides advanced, comprehensive digestive care.",
    sections: {
      overview: `Prachin Global Hospitals well-equipped Gastroenterology Department provides comprehensive treatment to patients with stomach ailments. Whether you require Diagnostic Tests, Endoscopic Procedures or Specialized treatments for addressing your Gastro issues, our Gastroenterologists are committed to delivering optimal outcomes.`,
      moreoverview: `Prachin Global Hospitals ensures that patients receive the highest quality care with advanced diagnostic and therapeutic procedures to address a wide range of gastrointestinal disorders. Additionally, we deliver specialized services such as Haemorrhoidal Band Ligation, aimed at offering effective solutions for specific conditions. Rest assured that at our Gastroenterology Department. `,

      diagnosticsTitle: "Advanced Gastroenterology Facilities",
      diagnostics: [
        "Advanced Endoscopy & ERCP Suite ",
        "World-class endoscopic instruments & imaging systems ",
        "Comprehensive diagnostic and therapeutic GI services ",
      ],
      proceduresTitle: "Services we offer:",
      procedures: [
        "Diagnostic Endoscopy",
        "Colonoscopy",
        "ERCP (Endoscopic Retrograde Cholangio Pancreatography)",
        "Therapeutic Endoscopic Interventions",
        "Barium Swallow",
        "Barium Enema",
        "Endoscopy and Colonoscopy Procedures",
        "Treatment for Acid Reflux, GERD, and Ulcers",
        "Management of IBS and Chronic Abdominal Pain",
        "Liver Disease and Hepatitis Management",
        "Advanced Care for Crohn’s Disease and Ulcerative Colitis",
        "Upper Gastrointestinal Series",
        "Upper GI Endoscopy",
        "Liver Biopsy",
        "Sigmoidoscopy",
        "Virtual Colonoscopy for Colorectal Cancer Screening",
        "Colectomy",
      ],
      screeningTitle: "Conditions We Treat",
      screeningContentList: [
        "Acid Reflux, GERD & Ulcers ",
        "IBS & Chronic Abdominal Pain ",
        "Liver Diseases & Hepatitis ",
        "Crohn’s Disease & Ulcerative Colitis ",
        "Colorectal & Digestive Disorders  ",
        "Haemorrhoids & GI Bleeding Disorders ",
      ],
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced gastroenterology expertise with compassionate care to deliver effective treatment and long-term digestive wellness.`,
      images: [Gastroenterologyimage1, Gastroenterologyimage2],
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "MR ANIL BOORLA ",
    //     dignity: "CONSULTANT GASTROENTEROLOGIST & HEPATOLOGIST",
    //     degree: "MBBS, MD (GENERAL MEDICINE), DM (GASTROENTEROLOGY)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },

  {
    slug: "surgical-gastroenterology",
    title: "Surgical Gastroenterology",
    icon: surgicalgastroenterologyIcon,
    shortdesc:
      "Prachin Global Hospitals Surgical Gastroenterology Department offers advanced digestive surgery.",
    banner: bannersurgicalgastroenterology,
    banner_m: bannersurgicalgastroenterology_m,
    sections: {
      overview: `Prachin Global Hospitals offers advanced Surgical Gastroenterology services for disorders of the digestive system using minimally invasive and laparoscopic techniques.`,

      moreoverview: `Our experienced surgical gastroenterologists provide comprehensive care for conditions affecting the esophagus, stomach, intestines, liver, pancreas, gallbladder and colorectal region with a focus on precision, safety and faster recovery.`,

      proceduresTitle: "Specialized Surgical Services",
      procedures: [
        "Esophagogastric surgery",
        "Pancreatic and biliary surgery",
        "Colorectal surgery",
        "Bariatric (weight-loss) surgery",
        "Liver and advanced gastrointestinal procedures",
        "Hernia & Gallbladder Surgery ",
        "Gastrointestinal Cancer Surgery ",
      ],
      screeningTitle: "Advanced Minimally Invasive Care",
      screeningSubTitle:
        "We use advanced laparoscopic and minimally invasive techniques to ensure:",
      screeningContentList: [
        "Smaller incisions & minimal scarring  ",
        "Reduced post-operative pain ",
        "Shorter hospital stays ",
        "Faster recovery & better outcomes   ",
      ],
      Quotationcontent: `At Prachin Global Hospitals, we combine surgical expertise with compassionate care to deliver safe, effective and patient-centric treatment for digestive disorders.`,
      images: [surgicalGastroenterologyimage1, surgicalGastroenterologyimage2],
    },
    doctors: [
      // {
      //   id: 1,
      //   name: "MR ANIL BOORLA ",
      //   dignity: "CONSULTANT GASTROENTEROLOGIST & HEPATOLOGIST",
      //   degree: "MBBS, MD (GENERAL MEDICINE), DM (GASTROENTEROLOGY)",
      //   image: Doctor1,
      // },
      // {
      //   id: 2,
      //   name: "DR AMULYA ",
      //    slug: "dr-amulya",
      //   dignity: "CONSULTANT CLINICAL NUTRITIONIST",
      //   degree: "BACHELORS IN CLINICAL NUTRITION & DIETETICS",
      //   image: AMULYA,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "orthopedics-joint-replacements",
    title: "Orthopedics & Joint Replacement",
    icon: orthopedicsIcon,
    shortdesc:
      "Prachin Global Hospitals Orthopedics & Joint Replacement Department offers advanced care.",
    banner: bannerOrthopedics,
    banner_m: bannerOrthopedics_m,
    sections: {
      overview: `Prachin Global Hospitals widely exploring as one of the best Orthopedic Hospitals in Telangana, our Orthepedic Division, led by internationally trained Surgeons, performs complex and high-precision procedures for the full range of Bone, Joint, Ligament, Tendon, Muscle and Spine conditions. With state-of-the-art Laminar-airflow, Heap Filters Operating Theatres, advanced imaging and a multidisciplinary team approach, we ensure uncompromised safety, precision and rapid recovery. Our programs include robotic Knee and Hip Replacement, Advanced Arthroscopy, Joint preservation, Sports Injury Management, Spine Surgery, Pediatric Orthopedics and comprehensive rehabilitation—delivering superior outcomes with minimal discomfort and shorter hospital stays.`,
      proceduresTitle: "Advanced Orthopedic Care",
      procedures: [
        "Robotic Knee & Hip Replacement ",
        "Minimally Invasive Arthroscopic Procedures ",
        "Shoulder, Knee & Hip Replacement Surgery ",
        "Ligament & Tendon Reconstruction ",
        "Sports Injury Management ",
        "Spine Surgery & Rehabilitation ",
      ],
      screeningTitle: "World-Class Infrastructure",
      screeningContentList: [
        "Laminar airflow modular operation theatres ",
        "Advanced imaging & diagnostics",
        "Robotic-assisted surgical technology ",
        "Dedicated physiotherapy & rehabilitation support  ",
      ],
      QuotationTitle: `Move Better. Live Better.`,
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced orthopedic expertise with compassionate care to restore mobility, reduce pain and improve quality of life.`,
      images: [Orthopedicsimage1, Orthopedicsimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. CHETAN NARRA ",
        slug: "dr-chetan-narra",
        dignity:
          "CONSULTANT ORTHOPEDICS & JOINT REPLACEMENT AND PAEDIATRICS ORTHOPEDIC SURGEON",
        degree: "MBBS, MS (ORTHO), FELLOW IN JOINT REPLACEMENT (FIJR) ",
        image: CHETAN,
      },
      {
        id: 2,
        name: "DR. RAMESH CHANDRA VADAPALLI ",
         slug: "dr-ramesh-chandra-vadapalli",
        dignity:
          "SENIOR CONSULTANT JOINT REPLACEMENT, ARTHROSCOPY & SPORTS MEDICINE SURGEON",
        degree:
          "MS (ORTHO-MANIPAL), FIJR, FISM (ARTHOSCOPY, JOINT REPLACEMENTS & PEDIATRIC ORTHO) & SPORTS MEDICINE ",
        image: RAMESH,
      },
      // {
      //   id: 3,
      //   name: "DR MADHUSUDHAN KOGILA",
      //   dignity: "CONSULTANT PHYSIOTHERAPIST",
      //   degree: "MASTERS IN SPORTS AND MUSCULOSKELETAL REHABILITATION",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "arthroscopy-arthroplasty-pediatric-orthopedics",
    title: "Arthroscopy, Arthroplasty",
    icon: arthroscopyIcon,
    shortdesc:
      "Prachin Global Hospitals Arthroscopy & Arthroplasty Department offers advanced joint care.",
    banner: bannerArthroscopy,
    banner_m: bannerArthroscopy_m,
    sections: {
      overview: `Prachin Global Hospitals widely exploring as one of the best Orthopedic Hospitals in Telangana, our Orthopedic Division, led by internationally trained Surgeons, performs complex and high-precision procedures for the full range of Bone, Joint, Ligament, Tendon, Muscle and Spine conditions. With state-of-the-art Laminar-airflow, Hepa Filters Operating Theatres, advanced imaging and a multidisciplinary team approach, we ensure uncompromised safety, precision and rapid recovery. Our programs include robotic Knee and Hip Replacement, Advanced Arthroscopy, Joint preservation, Sports Injury Management, Spine Surgery, Pediatric Orthopedics and comprehensive rehabilitation—delivering superior outcomes with minimal discomfort and shorter hospital stays.`,
      proceduresTitle: "Arthroscopy – Minimally Invasive Joint Care",
      proceduresDescription: `Advanced keyhole procedures for:`,
      procedures: [
        "ACL & PCL ligament reconstruction ",
        "Meniscus repair ",
        "Shoulder arthroscopy for rotator cuff injuries",
        "Ankle and hip arthroscopy",
        "Sports-related cartilage injury treatment ",
      ],
      proceduresNote: `Benefits include minimal pain, faster recovery, smaller incisions and shorter hospital stay.`,
      extraSectionTitle: "Arthroplasty – Advanced Joint Replacement",
      extraSectionContent: `We provide advanced joint replacement solutions including:`,
      // ✅ Converted to array for easy mapping
      arthroplastyList: [
        "Total Knee Replacement ",
        "Total Hip Replacement ",
        "Partial Joint Replacement ",
        "Revision Joint Replacement Surgery  ",
      ],
      extraSectionNote: `Using modern surgical techniques and advanced implants for improved mobility and long-term outcomes.`,
      screeningTitle: "Sports Medicine & Rehabilitation",
      screeningContentList: [
        "Advanced diagnostic imaging",
        "Non-surgical injury management",
        "Regenerative therapies",
        "Post-surgical physiotherapy",
        "Personalized rehabilitation programs",
      ],
      technologiesTitle: "Pediatric Orthopedics",
      technologiesNote: `Specialized orthopedic care for children with bone, joint, spine and developmental disorders using child-focused treatment approaches.`,
      images: [arthroscopyimage1, arthroscopyimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. RAMESH CHANDRA VADAPALLI ",
         slug: "dr-ramesh-chandra-vadapalli",
        dignity:
          "SENIOR CONSULTANT JOINT REPLACEMENT, ARTHROSCOPY & SPORTS MEDICINE SURGEON",
        degree:
          "MS (ORTHO-MANIPAL), FIJR, FISM (ARTHOSCOPY, JOINT REPLACEMENTS & PEDIATRIC ORTHO) & SPORTS MEDICINE ",
        image: RAMESH,
      },
      {
        id: 2,
        name: "DR. CHETAN NARRA",
        slug: "dr-chetan-narra",
        dignity:
          "CONSULTANT ORTHOPEDICS & JOINT REPLACEMENT AND PAEDIATRICS ORTHOPEDIC SURGEON",
        degree: "MBBS, MS (ORTHO), FELLOW IN JOINT REPLACEMENT (FIJR)",
        image: CHETAN,
      },
      // {
      //   id: 3,
      //   name: "DR MADHUSUDHAN KOGILA",
      //   dignity: "CONSULTANT PHYSIOTHERAPIST",
      //   degree: "MASTERS IN SPORTS AND MUSCULOSKELETAL REHABILITATION",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "urology",
    title: "Urology",
    icon: urologyIcon,
    shortdesc:
      "The Department of Urology at Prachin Global Hospitals is dedicated to the comprehensive diagnosis.",
    banner: bannerUrology,
    banner_m: bannerUrology_m,
    sections: {
      overview: `Prachin Global Hospitals offers comprehensive Urology, Andrology and Pediatric Urology services with advanced technology, minimally invasive procedures and expert specialist care.`,
      moreoverview: `We specialize in a wide range of services, including Stone Disease treatments (Laser Technology, ESWL, PCNL, URSL, CLP, PCCL), BPH treatment (minimally invasive techniques), Reconstructive Procedures (Ureter Re-implantation, Hypospadias Repair, Orchiopexy), Female Urology solutions (VVF repair, stress incontinence surgery, tubal recanalization), Stricture Urethra treatments (Optical Urethrotomy, Urethroplasty), Andrology services (male infertility evaluation, management, epididymal aspiration, testicular biopsy) and Erectile Dysfunction Management (Rigiscan assessment, vacuum therapy) As a leading Urology Hospital we are dedicated to delivering exceptional results across all our specialized services.`,
      proceduresTitle: "Advanced Urology Services",
      procedures: [
        "Kidney Stone Treatment (Laser, ESWL, PCNL, URSL)",
        "Prostate treatments, including laser surgery.",
        "Male infertility diagnosis and treatment.",
        "Erectile Dysfunction Management ",
        "Bladder control and incontinence management.",
        "Urological cancer screening and treatment.",
        "Female Urology & Reconstructive Procedures ",
        "Pediatric Urology Care ",
      ],
      images: [Urologyimage1, Urologyimage2],
      extraSectionTitle: "Specialized Treatments",
      // ✅ Converted to array for easy mapping
      arthroplastyList: [
        "TURP (monopolar and bipolar)",
        "Laser Prostate Surgery ",
        "Laparoscopic prostatectomy",
        "Urethroplasty & Optical Urethrotomy ",
        "Microscopic Varicocelectomy ",
        "TVT & TOT Procedures for Urinary Incontinence ",
      ],
      technologiesTitle: "Pediatric Urology",
      technologiesNote: `Specialized care for children with urinary and genital conditions, congenital abnormalities, infections and structural disorders through coordinated pediatric care.`,
      Quotationcontent: `We combine advanced urological expertise with compassionate care to deliver safe, effective and ethical treatment for patients of all age groups.`,
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "Dr. Arjun Reddy",
    //     dignity: "Senior Cardiologist",
    //     degree: "MD, DM (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },

  {
    slug: "pulmonology",
    title: "Pulmonology",
    icon: pulmonologyIcon,
    shortdesc:
      "Department of Pulmonary and Lung Sciences is home to a highly skilled team of experienced pulmonologists.",
    banner: bannerPulmonology,
    banner_m: bannerPulmonology_m,
    sections: {
      overview:
        "The Department of Pulmonology at Prachin Global Hospitals offers comprehensive, evidence-based respiratory care, respiratory critical care, interventional pulmonology and sleep medicine services for adults and children. Led by experienced specialists including Dr. Anusha Kantheti, our team focuses on accurate diagnosis, advanced treatment and long-term respiratory wellness.",
      diagnosticsMainTitle: `Key Services & Treatments`,
      diagnosticsTitle: "Comprehensive Services provide advanced treatment for",
      diagnostics: [
        "Asthma Treatment",
        "Chronic Obstructive Pulmonary Disease (COPD)",
        "Interstitial Lung Diseases (ILDs) ",
        "Bronchitis care",
        "Pleural Disorders ",
        "Bronchiectasis ",
        "Pneumonia treatment",
        "Tuberculosis management",
        "Lung infection treatment",
        "Flu & Allergies ",
        "COVID & Post-COVID Lung Conditions ",
        "Smoking-related lung disease care ",
        "Pulmonary Hypertension  ",
      ],
      proceduresTitle: "Respiratory Critical Care",
      proceduresDescription: "Management of:",
      procedures: [
        "Severe Respiratory Failure ",
        "Acute Lung Injury (ALI) ",
        "ARDS (Acute Respiratory Distress Syndrome) ",
        "Septicemia & Severe Lung Infections ",
        "ICU & Ventilator Support ",
        "Respiratory Emergencies ",
      ],
      conditionstreatedtitle: "Sleep Medicine",
      conditionstreateddesc: `Diagnosis and management of:`,
      conditionstreatedpoints: [
        "Sleep-related Breathing Disorders ",
        "Sleep Apnea & Snoring Disorders ",
      ],
      screeningTitle: "Diagnostics & Interventional Pulmonology",
      screeningContentList: [
        "Advanced Pulmonary Function Lab (PFT)",
        "High-Resolution CT Chest Imaging",
        "Fibre Optic Bronchoscopy (Diagnostic & Therapeutic)",
        "EBUS (Endobronchial Ultrasound)",
        "Lung Biopsies",
        "Medical Thoracoscopy & Pleural Procedures",
        "Advanced Respiratory Assessment",
      ],

      technologiesTitle:
        "Specialized Pulmonary Care with Multidisciplinary Approach",
      technologies: [
        "Pediatric Pulmonology",
        "Occupational Lung Disease Management",
        "Pulmonary Rehabilitation",
        "Smoking Cessation & Lifestyle Counselling",
        "Adult Immunization Programs",
        "Allergy Evaluation & Immunotherapy",
      ],
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced respiratory care with compassionate treatment to help patients achieve healthier lungs and better quality of life.`,
      images: [Pulmanologyimage1, Pulmanologyimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. ANUSHA KANTHETI",
         slug: "dr-anusha-kantheti",
        dignity: "CONSULTANT PULMONOLOGIST & SOMNOLOGIST",
        degree:
          "MBBS (GOLD MEDAL), DNB RESPIRATORY MEDICINE, CERTIFIED SLEEP MEDICINE SPECIALIST, FID (UK) ",
        image: ANUSHA,
      },
      // {
      //   id: 2,
      //   name: "Dr. Meera Sharma",
      //   dignity: "CTVS Specialist",
      //   degree: "MS, MCh (Cardiothoracic Surgery)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "sports-medicine",
    title: "Sports Medicine",
    category: "core",
    icon: sportsIcon,
    shortdesc:
      "Expert sports injury treatment and rehabilitation for faster recovery and peak performance.",
    banner: bannersports,
    banner_m: bannersports_m,
    sections: {
      overview: `The Sports Medicine Department at Prachin Global Hospitals is dedicated to the prevention, diagnosis, treatment and rehabilitation of sports-related injuries and musculoskeletal conditions. Our expert team provides specialized care for athletes, fitness enthusiasts and individuals suffering from joint, muscle, ligament, tendon and bone injuries. With advanced medical technology and personalized treatment plans, we help patients recover safely and return to their active lifestyles with confidence.`,
      moreoverview: `The department offers comprehensive services including sports injury management, ligament reconstruction, arthroscopy, fracture care, joint pain treatment, physiotherapy, rehabilitation programs, muscle strengthening, posture correction and performance enhancement guidance. We specialize in treating conditions such as ACL tears, meniscus injuries, tennis elbow, shoulder dislocations, ankle sprains, muscle strains and overuse injuries.`,

      whychoosetitle: "Why Choose Us",
      whychoosepoints: [
        "Expert Sports Medicine and Orthopedic Specialists",
        "Advanced Diagnosis and Treatment for Sports Injuries",
        "Personalized Rehabilitation and Recovery Programs",
        "Minimally Invasive and Arthroscopic Procedures",
      ],
      images: [sports1, sports2],
    },
    doctors: [
        {
        id: 1,
        name: "DR. RAMESH CHANDRA VADAPALLI ",
         slug: "dr-ramesh-chandra-vadapalli",
        dignity:
          "SENIOR CONSULTANT JOINT REPLACEMENT, ARTHROSCOPY & SPORTS MEDICINE SURGEON",
        degree:
          "MS (ORTHO-MANIPAL), FIJR, FISM (ARTHOSCOPY, JOINT REPLACEMENTS & PEDIATRIC ORTHO) & SPORTS MEDICINE ",
        image: RAMESH,
      },
      // {
      //   id: 2,
      //   name: "Dr. Meera Sharma",
      //   dignity: "CTVS Specialist",
      //   degree: "MS, MCh (Cardiothoracic Surgery)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "vascular-surgery",
    title: "Vascular Surgery",
    icon: vascularIcon,
    shortdesc:
      "Vascular diseases affect arteries, veins and lymphatic vessels, impacting circulation.",
    banner: bannerVascular,
    banner_m: bannerVascular_m,
    sections: {
      overview: `Prachin Global Hospitals is a leading centre for Vascular & Endovascular Surgery in Telangana, offering advanced care for diseases affecting arteries, veins and the lymphatic system.`,
      moreoverview: `Our expert vascular surgeons provide comprehensive, evidence-based treatment for both routine and complex vascular conditions, including limb-saving emergency care.`,
      proceduresTitle: "Conditions We Treat",
      procedures: [
        "Peripheral Artery Disease (PAD)",
        "Critical Limb Ischemia",
        "Varicose Veins & Venous Insufficiency",
        "Deep Vein Thrombosis (DVT)",
        "Diabetic Foot with Vascular Complications",
        "Carotid Artery Disease",
        "Aortic Aneurysms",
        "Lymphedema",
      ],
      conditionstreatedtitle: "Advanced Vascular Procedures",
      conditionstreatedpoints: [
        "Endovascular (Minimally Invasive) Treatments using catheters, balloons & stents",
        "Open Vascular Reconstruction Surgery",
        "Varicose Vein Laser & Ablation Procedures",
        "Limb Salvage Procedures for Diabetic Foot",
        "Emergency Vascular Interventions (24/7)",
      ],
      technologiesTitle: "What Is Vascular & Endovascular Surgery?",
      technologiesNote: `Vascular surgery is a super-specialty focused on treating diseases of blood vessels outside the heart and brain. It combines open surgery and minimally invasive techniques to restore proper blood flow and prevent complications such as limb loss and stroke risk.`,
      technologiesNote2: `Vascular & Endovascular Surgery is the specialized field focused on treating diseases of the circulatory system outside the heart and brain. This includes: It is a super specialty requiring advanced training beyond general surgery, ensuring every patient receives the most appropriate, evidence-based vascular care.`,
      images: [Vascularimage1, Vascularimage2],
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "Dr. Arjun Reddy",
    //     dignity: "Senior Cardiologist",
    //     degree: "MD, DM (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },
  {
    slug: "nephrology",
    title: "Nephrology",
    icon: nephrologyIcon,
    shortdesc:
      "Our Nephrology Department offers specialized, compassionate kidney care.",
    banner: bannerNephrology,
    banner_m: bannerNephrology_m,
    sections: {
      overview: `Our Nephrology Department is offering specialized and compassionate kidney care for patients of all ages. Under the guidance of top Nephrologists and supported by advanced medical infrastructure, our hospital delivers world-class diagnosis and treatment for a wide range of kidney disorders.`,

      moreoverview:
        "As a leading Kidney Specialist Hospital our multidisciplinary Nephrology team focuses on accurate diagnosis, preventive care, advanced Dialysis and Transplant preparation — ensuring the best outcomes for every patient.",

      diagnosticsTitle: "Advanced Nephrology Care ",
      diagnosticsDescription:
        "We combine clinical expertise with cutting-edge technology to deliver seamless Renal Care. Our Nephrology Units are equipped with next-generation Dialysis Systems, Renal Imaging and critical-care facilities for continuous kidney monitoring.",
      diagnosticssubtitle: `We deliver modern renal care using advanced systems and critical care support:`,
      diagnostics: [
        "Hemodiafiltration (HDF) for Enhanced Toxin Removal",
        "Continuous Renal Replacement Therapy (CRRT) for Critically Ill Patients",
        "Continuous Ambulatory Peritoneal Dialysis (CAPD) for Home-Based Care",
        "Advanced Dialysis Units with Real-Time Monitoring",
        "Renal Biopsy & Vascular Access Procedures (AV Fistula, Permcath)",
      ],
      proceduresTitle: "Conditions We Treat",
      procedures: [
        "Chronic Kidney Disease (CKD)",
        "Acute Kidney Failure",
        "Diabetic & Hypertensive Kidney Disease",
        "Kidney Stones & Urinary Tract Infections",
        "Glomerulonephritis & Nephrotic Syndrome",
        "Electrolyte & Acid–Base Imbalance",
        "Kidney Disease in Pregnancy",
        "Autoimmune Kidney Disorders",
      ],
      conditionstreatedtitle: "Comprehensive Renal Services",
      conditionstreatedpoints: [
        "Hemodialysis & Peritoneal Dialysis",
        "Kidney Transplant Evaluation",
        "Post-Transplant Care & Monitoring",
        "Preventive Kidney Screening",
        "Critical Care Nephrology Support",
      ],
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced nephrology expertise with compassionate care to deliver reliable, long-term kidney health solutions.`,
      images: [Nephrologyimage1, Nephrologyimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. RANGANATH",
         slug: "dr-ranganath",
        dignity: "CONSULTANT NEPHROLOGIST",
        degree: "MBBS, MD, DM (NEPHROLOGY)",
        image: Doctor1,
      },
      // {
      //   id: 2,
      //   name: "Dr. Meera Sharma",
      //   dignity: "CTVS Specialist",
      //   degree: "MS, MCh (Cardiothoracic Surgery)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "rheumatology",
    title: "Rheumatology",
    icon: RheumatologyIcon,
    banner: bannerRheumatology,
    banner_m: bannerRheumatology_m,
    shortdesc:
      "Rheumatic diseases are conditions that affect the joints, tendons, ligaments, bones and muscles.",
    sections: {
      overview: `Prachin Global Hospitals provides advanced Rheumatology care for disorders affecting joints, muscles, bones, ligaments and connective tissues. Our expert rheumatologists deliver accurate diagnosis and evidence-based treatment focused on pain relief, improved mobility and long-term disease control.`,
      proceduresTitle: "Common Symptoms",
      procedures: [
        "Joint Pain and Swelling",
        "Morning Stiffness",
        "Reduced Joint Movement",
        "Muscle Pain and Fatigue",
        "Inflammation of Joints and Tissues",
      ],
      images: [rheumatologyimage1, rheumatologyimage2],
      conditionstreatedtitle: "Conditions Treated",
      conditionsTreated: [
        "Rheumatoid Arthritis",
        "Osteoarthritis",
        "Osteoporosis",
        "Gout",
        "Psoriatic Arthritis",
        "Ankylosing Spondylitis",
        "Systemic Lupus Erythematosus (SLE)",
        "Connective Tissue Disorders",
        "Fibromyalgia",
        "Juvenile (Childhood) Arthritis",
        "Metabolic Bone Disorders",
      ],
      screeningTitle: "Comprehensive Rheumatology Care",
      screeningSubTitle: `We offer complete evaluation and treatment, including:`,
      screeningContentList: [
        "Specialist Consultation & Clinical Assessment",
        "Advanced Lab Investigations",
        "Imaging (MRI, CT, Ultrasound, DEXA Scan)",
        "Joint Injections (Intra-Articular & Soft Tissue)",
        "Pain Management Therapies",
        "Physiotherapy & Rehabilitation Support",
        "Lifestyle & Dietary Guidance",
      ],
      technologiesTitle: "Multidisciplinary Approach",
      technologiesSubTitle: "Our care team includes:",
      technologies: [
        "Rheumatologists",
        "Orthopedic Specialists",
        "Physiotherapists",
        "Rehabilitation Experts",
        "Trained Nursing Staff",
      ],
      technologiesNote:
        "Working together to ensure better outcomes and faster recovery.",
      QuotationTitle: `Advanced Joint & Autoimmune Care You Can Trust`,
      Quotationcontent: `At Prachin Global Hospitals, we combine clinical expertise with compassionate care to help patients manage chronic rheumatic diseases and improve quality of life.`,
    },
    doctors: [
      {
        id: 1,
        name: "DR. RAMKRISHNA PURAMWAR",
        slug: "dr-ramkrishna-puramwar",
        dignity: "CONSULTANT GENERAL MEDICINE & RHEUMATOLOGIST",
        degree: "MBBS, MD (GENERAL MEDICINE), FELLOWSHIP IN RHEUMATOLOGY",
        image: RAMKRISHNA,
      },
      // {
      //   id: 2,
      //   name: "Dr. Meera Sharma",
      //   dignity: "CTVS Specialist",
      //   degree: "MS, MCh (Cardiothoracic Surgery)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "ent",
    title: "ENT",
    icon: ENTIcon,
    shortdesc:
      "ENT Department provides advanced care for ear, nose and throat conditions.",
    banner: bannerENT,
    banner_m: bannerENT_m,
    sections: {
      overview:
        "Prachin Global Hospitals offers comprehensive ENT (Ear, Nose & Throat) care with advanced diagnostic and surgical expertise, including complex Head & Neck, Skull Base, Pediatric ENT and Facial Trauma procedures.",
      moreoverview:
        "Our experienced ENT specialists provide precise, patient-centric treatment using advanced endoscopic and minimally invasive techniques for both routine and complex conditions.",
      diagnosticsTitle: "ENT Services We Offer",
      diagnostics: [
        "Ear infections, hearing loss & ear surgeries",
        "Sinusitis & advanced sinus surgeries (FESS)",
        "Tonsil & adenoid surgeries",
        "Voice & throat disorder management",
        "Nasal allergy & septal correction surgeries",
        "Vertigo & balance disorder evaluation",
        "Pediatric ENT care",
      ],

      proceduresTitle: "Skull Base & Advanced ENT Surgery",
      procedures: [
        "Endoscopic skull base surgery",
        "Pituitary tumor access surgeries",
        "Endonasal DCR procedures",
        "Orbital & optic nerve decompression procedures",
        "Complex nasal & sinus tumor removal",
        "Minimally invasive head & neck surgeries",
        "Reconstructive ENT procedures",
      ],
      images: [ENTimage1, ENTimage2],
      technologiesTitle: "Facial Trauma Management",
      technologies: [
        "Facial fracture management",
        "Nasal & orbital trauma care",
        "Head & neck injury reconstruction",
        "Comprehensive trauma & emergency ENT support",
      ],
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced ENT expertise with cutting-edge skull base surgery techniques to deliver safe, effective and comprehensive care.`,
    },
    doctors: [
      {
        id: 1,
        name: "DR. PURVA ARTHAM",
         slug: "dr-purva-artham",
        dignity: "CONSULTANT ENT, HEAD & NECK, SKULL BASE SURGEON",
        degree: "MBBS, MS (ENT), SKULL BASE SURGERY (MALAYSIA)",
        image: PURVA,
      },
      // {
      //   id: 2,
      //   name: "Dr. Meera Sharma",
      //   dignity: "CTVS Specialist",
      //   degree: "MS, MCh (Cardiothoracic Surgery)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "general-medicine",
    title: "General Medicine & Diabetology",
    icon: GeneralIcon,
    shortdesc:
      "General Medicine provides accurate diagnosis and effective treatment for all ages.",
    banner: bannerGeneral,
    banner_m: bannerGeneral_m,
    sections: {
      overview:
        "PExpert General Medicine Care for all age groups is your first step to accurate diagnosis and effective treatment. Our General Medicine and Internal Medicine Department offers comprehensive Outpatient and Inpatient care for a wide range of medical conditions i.e. Seasonal and Viral Fever, Fatigue, Chronic Diseases or unexplained symptoms and Diabetic Treatments. Our Physicians provide precise diagnosis, timely treatment and holistic care management.",
      moreoverview:
        "Our physicians manage both acute and chronic conditions with a patient-centric approach to improve overall health and long-term well-being.",
      diagnosticsTitle: "Key Services",
      diagnostics: [
        "Treatment of fever, viral infections & respiratory illnesses ",
        "Diabetes, hypertension & thyroid disorder management ",
        "Evaluation of fatigue & unexplained symptoms ",
        "Preventive health check-ups & screenings ",
        "Lifestyle, diet & wellness counselling ",
        "Coordination with super-specialty departments ",
      ],
      QuotationTitle: `Complete Medical Care You Can Trust`,
      Quotationcontent: `At Prachin Global Hospitals, we ensure reliable, comprehensive and continuous medical care to support better health outcomes at every stage of life.`,
      images: [Generalimage1, generalimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. RAMKRISHNA PURAMWAR",
        slug: "dr-ramkrishna-puramwar",
        dignity: "CONSULTANT GENERAL MEDICINE & RHEUMATOLOGIST",
        degree: "MBBS, MD (GENERAL MEDICINE), FELLOWSHIP IN RHEUMATOLOGY",
        image: RAMKRISHNA,
      },
      //  {
      //   id: 2,
      //   name: "DR SURESH BABU VALLEPU",
      //      slug: "dr-suresh-babu-vallepu",
      //   dignity: "CONSULTANT NEURO PHYSICIAN",
      //   degree: "MBBS, MD (GENERAL MEDICINE), DM (NEUROLOGY)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "general-laparoscopy-surgery",
    title: "General & Laparoscopic Surgery",
    icon: LaparoscopyIcon,
    shortdesc:
      "General & Laparoscopy Surgery offers advanced, minimally invasive surgical care.",
    banner: bannerLaparoscopy,
    banner_m: bannerLaparoscopy_m,
    sections: {
      overview:
        "Prachin Global Hospitals offers advanced General and Laparoscopic Surgical care using minimally invasive and conventional techniques. Our expert surgeons focus on precision, safety, faster recovery and minimal pain, supported by close clinical monitoring and dedicated nursing care.",
      diagnosticsMainTitle: `Key Surgical Services`,
      diagnosticsTitle: "Laparoscopic (Minimally Invasive) Surgeries)",
      diagnostics: [
        "Gallbladder removal (Cholecystectomy) ",
        "Hernia repair (Inguinal, Ventral, Umbilical) ",
        "Appendectomy ",
        "Colectomy (Colon surgery) ",
        "Splenectomy ",
      ],

      proceduresTitle: "General & Open Surgeries",
      procedures: [
        "Abdominal surgeries for complex conditions",
        "Emergency surgical procedures  ",
        "Minor procedures (lumps, cysts, abscess removal) ",
      ],
      images: [Laprosopyimage1, Laprosopyimage2],
      technologiesTitle: "Specialised Surgical Care",
      technologies: [
        "Laser proctology procedures ",
        "Pediatric surgery ",
        "Comprehensive emergency surgical care ",
      ],
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced surgical expertise with compassionate care to ensure safe outcomes and quicker return to normal life.`,
    },
    doctors: [
      {
        id: 1,
        name: "DR. E DEBARAJU REDDY",
        slug: "dr-e-debaraju-reddy",
        dignity:
          "CONSULTANT GENERAL & LAPAROSCOPIC SURGEON AND CHIEF MEDICAL SUPERITENDENT",
        degree: "MBBS, AFIH, DNB, FMAS, Dip. MAS, FALS, MBA, GMHE (IIM-B)",
        image: DEBARAJU,
      },
      {
        id: 2,
        name: "DR. SYAM BABU KATURI",
        slug: "dr-syam-babu-katuri",
        dignity: "CONSULTANT GENERAL, LAPAROSCOPIC & LASER SURGEON",
        degree:
          "MBBS, MS (GENERAL SURGERY), FELLOW IN MINIMAL ACCESS SURGERY (FMAS)",
        image: SYAMBABU,
      },
      // {
      //   id: 3,
      //   name: "DR VAMSHI KRISHNA S",
      //   dignity: "CONSULTANT GENERAL SURGEON",
      //   degree: "MBBS, MS (GENERAL SURGERY)",
      //   image: VAMSHI,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "obstetrics-gynecology",
    title: "Obstetrics & Gynaecology",
    icon: obstetricsIcon,
    shortdesc:
      "Obstetrics & Gynaecology Department provides advanced care for women’s health and pregnancy.",
    banner: bannerObstetrics,
    banner_m: bannerObstetrics_m,
    sections: {
      overview: `Our Obstetrics and Gynaecology Department is equipped dedicated Department with advanced Technology, including Ultrasound Machines and monitoring equipment. This allows us to provide accurate diagnosis and exceptional care throughout pregnancy and beyond. Our team of expert Obstetricians and Gynaecologists committed to women’s health and well-being with a wealth of knowledge and a compassionate approach providing comprehensive care that addresses a wide range of women’s health concerns.`,

      moreoverview: `Our team of Obstetrics and Gynaecology dedicate to comprehensive women’s healthcare, from routine check-ups to expert maternity care with trust. Our specialists provide personalized prenatal and postnatal care, ensuring a safe and joyful journey into motherhood and compassionate care tailored to your unique needs.`,
      diagnosticsTitle: "Our Women’s Care Services",
      diagnostics: [
        "Routine Gynaecological Check-Ups",
        "Prenatal & Postnatal Care",
        "Normal & High-Risk Pregnancy Management",
        "Painless (Epidural) Delivery Options",
        "Infertility Evaluation & Care",
        "Menstrual & Hormonal Disorder Management",
        "Gynaecological Surgeries (Minimally Invasive & Robotic)",
      ],
      proceduresTitle: "Advanced Maternal & Neonatal Care",
      procedures: [
        "Dedicated Labour & Delivery Suite",
        "Advanced Operation Theatre Facilities",
        "Robotic Surgery Capability",
        "Fully Equipped Mother & Child Care Unit",
        "State-of-the-Art NICU (Neonatal Intensive Care Unit)",
        "24/7 Emergency Obstetric & Neonatal Support",
      ],
      extraSectionTitle: "High-Risk Pregnancy & Delivery Care",
      extraSectionContent: `Our expert team specializes in managing high-risk pregnancies with continuous monitoring, advanced diagnostics and individualized care plans to ensure safe outcomes for both mother and baby.`,
      technologiesTitle: `Personalized Maternity Care`,
      technologiesNote: `We create a customised birth plan for every mother, ensuring comfort, safety and emotional support throughout pregnancy, labour and delivery. Our team is committed to making your journey into motherhood safe, smooth and joyful.`,
      QuotationTitle: `Care You Can Trust for Mother & Child`,
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced medical care with compassion to ensure safe motherhood and healthy beginnings for every newborn.`,
      images: [gynecologyimage1, gynecologyimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. AMULYA ",
         slug: "dr-amulya",
        dignity: "CONSULTANT CLINICAL NUTRITIONIST",
        degree: "BACHELORS IN CLINICAL NUTRITION & DIETETICS",
        image: AMULYA,
      },
      {
        id: 2,
        name: "DR. BINDU BHARGAVI CH",
         slug: "dr-bindu-bhargavi-ch",
        dignity:
          "CONSULTANT OBSTETRICIAN & GYNEACOLOGIST AND LAPAROSCOPIC SURGEON",
        degree: "MMBBS, DGO, DNB, FMAS, DMAS, FRM",
        image: BINDU,
      },
      {
        id: 3,
        name: "DR. GADDAM SHAMILI",
        slug: "dr-gaddam-shamili",
        dignity: "CONSULTANT OBSTETRICIAN & GYNAECOLOGIST",
        degree: "MS (OBG), MRCOG - INFERTILITY",
        image: SHAMILI,
      },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "pediatrics-neonatology",
    title: "Pediatrics & Neonatology",
    icon: pediatricsIcon,
    shortdesc:
      "Pediatrics & Neonatology provides comprehensive care for infants, children and adolescents.",
    banner: bannerPediatrics,
    banner_m: bannerPediatrics_m,
    sections: {
      overview: `Prachin Global Hospitals provides comprehensive Pediatric and Neonatal care for infants, children and adolescents with a focus on growth, development, prevention and advanced medical treatment.`,
      moreoverview: `Our experienced pediatricians and neonatologists deliver compassionate, evidence-based care from birth through adolescence.`,
      diagnosticsTitle: "Pediatric Care Services",
      diagnostics: [
        "Routine Health Check-Ups & Growth Monitoring",
        "Immunization & Preventive Care",
        "Management of Acute Illnesses (Fever, Infections, Cough)",
        "Chronic Disease Care (Asthma, Diabetes, Epilepsy)",
        "Developmental & Milestone Assessment",
        "Specialized Pediatric Subspecialty Support",
      ],

      proceduresTitle: "Neonatology & NICU – (Level III)",
      procedures: [
        "Advanced Neonatal Intensive Care Unit (NICU) Support",
        "Care for Premature & Low Birth Weight Babies",
        "Management of High-Risk Newborns",
        "Respiratory & Life-Support Care (Ventilators, Incubators)",
        "Phototherapy for Neonatal Jaundice",
        "Critical Newborn Monitoring & Emergency Care",
      ],
      proceduresNote: `We strongly support families through every stage of newborn care with emotional guidance, clear communication and continuous support during NICU stay and recovery.`,
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced neonatal science with compassionate pediatric care to ensure every child gets the healthiest start in life.`,
      images: [pediatricsimage1, pediatricsimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. SUNEEL KUMAR KOMMINENI",
        slug: "dr-suneel-kumar-kommineni",
        dignity: "CONSULTANT PEDIATRICIAN & NEONATOLOGIST",
        degree: "MBBS, MD (PEDIATRICS), FELLOWSHIP IN NEONATOLOGY ",
        image: SUNEEL,
      },
      // {
      //   id: 2,
      //   name: "Dr. Meera Sharma",
      //   dignity: "CTVS Specialist",
      //   degree: "MS, MCh (Cardiothoracic Surgery)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "pediatric-surgery",
    title: "Pediatric surgery",
    category: "core",
    icon: pedisurgeryIcon,
    shortdesc:
      "Advanced pediatric surgical care for newborns, children and adolescents with specialized treatments.",
    banner: bannerpediatricsurgery,
    banner_m: bannerpediatricsurgery_m,
    sections: {
      overview: `The Pediatric Surgery Department at Prachin Global Hospitals is dedicated to providing specialized surgical care for newborns, infants, children and adolescents with compassion, precision and advanced medical expertise. Our department offers comprehensive evaluation, diagnosis and treatment for a wide range of pediatric surgical conditions, ensuring the highest standards of safety and care for every child.`,
      moreoverview: `We provide treatment for congenital anomalies, neonatal surgical conditions, gastrointestinal disorders, hernias, appendicitis, urological conditions, trauma care, pediatric tumors and minimally invasive laparoscopic surgeries. Our experienced pediatric surgeons work closely with pediatricians, anesthesiologists, intensivists and nursing teams to ensure complete and coordinated care throughout the treatment process.`,
      whychoosetitle: "Why Choose Us",
      whychoosepoints: [
        "Specialized Surgical Care for Newborns, Infants, Children and Adolescents",
        "Treatment for Congenital and Birth-Related Abnormalities",
        "Pediatric Laparoscopic and Minimally Invasive Surgeries",
      ],
      images: [pediatric1, pediatric2],
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "DR. MADHUSUDHAN KOGILA",
    //     dignity: "CONSULTANT PHYSIOTHERAPIST",
    //     degree: "MASTERS IN SPORTS AND MUSCULOSKELETAL REHABILITATION",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },
  {
    slug: "pediatric-orthopedics",
    title: "Pediatric Orthopedics",
    category: "core",
    icon: pediorthoIcon,
    shortdesc:
      "Specialized orthopedic care for children with bone, joint, spine and growth-related conditions.",
    banner: bannerPediatricortho,
    banner_m: bannerPediatricortho_m,
    sections: {
      overview: `The Pediatric Orthopedics Department at Prachin Global Hospitals specializes in the diagnosis, treatment and management of bone, joint, muscle and spine conditions in children from infancy through adolescence. Our expert pediatric orthopedic specialists provide comprehensive care for congenital disorders, developmental abnormalities, sports injuries, fractures, deformities and trauma-related conditions with a child-centered and compassionate approach.`,
      moreoverview: `The department offers advanced treatment for conditions such as clubfoot, scoliosis, hip disorders, limb deformities, cerebral palsy-related orthopedic issues, fractures, growth plate injuries and pediatric sports injuries. We focus on accurate diagnosis and personalized treatment plans to ensure proper growth, mobility and long-term musculoskeletal health for every child.`,
      whychoosetitle: "Why Choose Us",
      whychoosepoints: [
        "Experienced Pediatric Orthopedic Specialists",
        "Advanced Treatment for Bone, Joint and Spine Disorders in Children",
        "Child-Friendly and Compassionate Healthcare Environment",
        "Specialized Care for Congenital and Developmental Conditions",
      ],
      images: [pediatricsorthopedics1, pediatricsorthopedics2],
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "DR. MADHUSUDHAN KOGILA",
    //     dignity: "CONSULTANT PHYSIOTHERAPIST",
    //     degree: "MASTERS IN SPORTS AND MUSCULOSKELETAL REHABILITATION",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },
  {
    slug: "maxillofacial",
    title: "Maxillofacial & Reconstructive Surgery",
    icon: MaxiIcon,
    shortdesc:
      "Dentistry Department offers expert care by experienced dental specialists.",
    banner: bannerDental,
    banner_m: bannerDental_m,
    sections: {
      overview:
        "Prachin Global Hospitals offers comprehensive Dental, Maxillofacial and Reconstructive Surgery services with advanced technology, precision care and personalized treatment for patients of all ages.",
      moreoverview:
        "Our expert team provides complete oral, jaw, facial and reconstructive care under one roof.",
      // diagnosticsTitle: "Dental Services",
      // diagnostics: [
      //   "General & Preventive Dental Care",
      //   "Root Canal Treatment (RCT)",
      //   "Gum Disease (Periodontal) Treatment",
      //   "Dental Implants & Prosthetics",
      //   "Orthodontics (Braces & Aligners)",
      //   "Cosmetic & Aesthetic Dentistry",
      // ],
      proceduresTitle: "Maxillofacial & Reconstructive Surgery",
      procedures: [
        "Facial Trauma & Fracture Management",
        "Face Reconstruction Surgeries",
        "Oral Cancer Resection & Reconstruction",
        "Microvascular Surgeries",
        "Orthognathic (Jaw Correction) Surgeries",
        "TMJ Disorder Treatment",
        "Jaw Cyst & Tumor Surgeries",
        "Feminization Surgeries",
        "Complex Oral & Jaw Reconstruction",
      ],
      Quotationcontent: `At Prachin Global Hospitals, we combine clinical expertise with reconstructive precision to restore function, aesthetics and confidence.`,
      images: [Dentalimage1, Dentalimage2],
    },
    doctors: [
      {
        id: 1,
        name: "DR. AVINASH BASWARAJU",
        slug: "dr-avinash-baswaraju",
        dignity: "CONSULTANT MAXILLO FACIAL & FACE RECONSTRUCTIVE SURGEON",
        degree: "MDS, MPH (AUS), FELLOWSHIP IN FACE RECONSTRUCTIVE SURGERY ",
        image: AVINASH,
      },
      {
        id: 2,
        name: "DR. SAMANVITHA S",
         slug: "dr-samanvitha-s",
        dignity: "CONSULTANT DENTAL SURGEON",
        degree: "BDS, MDS",
        image: Doctor1,
      },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "dental",
    title: "Dental",
    category: "core",
    icon: DentalIcon,
    shortdesc:
      "Advanced dental care with modern treatments for healthy, confident smiles.",
    banner: bannerdental,
    banner_m: bannerdental_m,
    sections: {
      overview: `The Dental Super Specialty Department at Prachin Global Hospitals is dedicated to providing advanced, comprehensive and patient centered dental care under one roof. Equipped with modern technology and a team of experienced dental specialists, the department offers a wide range of treatments for patients of all age groups. Our services include preventive dentistry, cosmetic dentistry, dental implants, root canal treatments, crowns and bridges, orthodontics including braces and aligners, pediatric dental care, gum disease treatment, wisdom tooth extraction, oral and maxillofacial surgeries and complete smile makeovers.`,
      diagnosticsTitle: "Dental Services",
      diagnostics: [
        "General & Preventive Dental Care",
        "Root Canal Treatment (RCT)",
        "Gum Disease (Periodontal) Treatment",
        "Dental Implants & Prosthetics",
        "Orthodontics (Braces & Aligners)",
        "Cosmetic & Aesthetic Dentistry",
      ],

      proceduresTitle: "Why Choose Us",
      procedures: [
        "Experienced and Highly Qualified Dental Specialists",
        "Advanced Technology and Modern Dental Equipment",
        "Painless and Patient-Friendly Treatment Approach",
        "Comprehensive Dental Care Under One Roof",
      ],
      images: [dental1, dental2],
    },
    doctors: [
      // {
      //   id: 1,
      //   name: "DR MADHUSUDHAN KOGILA",
      //   dignity: "CONSULTANT PHYSIOTHERAPIST",
      //   degree: "MASTERS IN SPORTS AND MUSCULOSKELETAL REHABILITATION",
      //   image: Doctor1,
      // },
      {
        id: 2,
        name: "DR. SAMANVITHA S",
         slug: "dr-samanvitha-s",
        dignity: "CONSULTANT DENTAL SURGEON",
        degree: "BDS, MDS",
        image: SAMANVITHA,
      },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "plastic-surgery",
    title: "Plastic Surgery",
    icon: PlasticSurgeryIcon,
    shortdesc:
      "Plastic Surgery provides advanced reconstructive and cosmetic care.",
    banner: bannerPlastic,
    banner_m: bannerPlastic_m,
    sections: {
      overview: `Prachin Global Hospitals offers advanced Plastic and Reconstructive Surgery services focused on restoring function, improving appearance and rebuilding confidence through precise, safe and modern surgical techniques.`,
      moreoverview:
        "Our expert plastic surgeons provide both reconstructive and aesthetic procedures using evidence-based, patient-centric care.",
      diagnosticsMainTitle: "Our Services",
      diagnosticsTitle: "Reconstructive Surgery",
      diagnostics: [
        "Trauma & accident reconstruction",
        "Burn injury management",
        "Congenital deformity correction",
        "Skin grafting & tissue reconstruction",
      ],

      proceduresTitle: "Cosmetic (Aesthetic) Surgery",
      procedures: [
        "Facial aesthetic procedures",
        "Body contouring & liposuction",
        "Scar revision & skin correction",
        "Breast cosmetic procedures",
      ],
      technologiesTitle: "Micro & Hand Surgery",
      technologies: [
        "Complex hand injuries ",
        "Nerve & tendon repair ",
        "Microvascular reconstruction ",
      ],
      QuotationTitle: `Restore Function. Rebuild Confidence.`,
      Quotationcontent: `At Prachin Global Hospitals, we combine surgical precision with artistic expertise to deliver safe reconstruction and refined aesthetic results.`,
      images: [Plastic1, Plastic2],
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "Dr. Arjun Reddy",
    //     dignity: "Senior Cardiologist",
    //     degree: "MD, DM (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },
  {
    slug: "endocrinology",
    title: "Endocrinology",
    icon: EndocrinologyIcon,
    shortdesc:
      "Endocrinology provides advanced care for hormone-related disorders.",
    banner: bannerEndocrinology,
    banner_m: bannerEndocrinology_m,
    sections: {
      overview: `Prachin Global Hospitals provides comprehensive Endocrinology services for the diagnosis and management of hormonal, metabolic and gland-related disorders with a focus on long-term health and balanced well-being.`,
      moreoverview: `Our expert endocrinologists deliver evidence-based, patient-centric care using advanced diagnostic tools and personalized treatment plans.`,
      diagnosticsTitle: "Conditions We Treat",
      diagnostics: [
        "Diabetes (Type 1 & Type 2)",
        "Thyroid disorders (Hypothyroidism & Hyperthyroidism)",
        "Obesity & metabolic syndrome",
        "PCOS (Polycystic Ovary Syndrome)",
        "Growth & puberty disorders",
        "Hormonal imbalance disorders",
        "Pituitary & adrenal gland disorders",
        "Osteoporosis & metabolic bone diseases",
      ],

      proceduresTitle: "Our Services",
      procedures: [
        "Advanced hormonal testing & diagnostics",
        "Diabetes management & insulin therapy",
        "Thyroid evaluation & treatment",
        "Lifestyle & weight management programs",
        "Endocrine disorder counseling & follow-up care",
        "Preventive metabolic health screening",
      ],
      Quotationcontent: `At Prachin Global Hospitals, we combine medical expertise with compassionate care to help patients achieve hormonal balance and healthier living.`,
      images: [Endocrinologyimage1, Endocrinologyimage2],
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "Dr. Arjun Reddy",
    //     dignity: "Senior Cardiologist",
    //     degree: "MD, DM (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },
  {
    slug: "anaesthesiology-pain",
    title: "Anaesthesiology & Pain Management",
    icon: anaesthesiologyIcon,
    banner: bannerAnaesthesiology,
    banner_m: bannerAnaesthesiology_m,
        shortdesc:
      "Prachin Global Hospitals provides advanced Anaesthesiology, Pain Management and ERAS (Enhanced Recovery After Surgery) services.",
    sections: {
      overview: `Prachin Global Hospitals provides advanced Anaesthesiology, Pain Management and ERAS (Enhanced Recovery After Surgery) services to ensure safe, comfortable and pain-free care for all surgical and medical procedures.`,

      moreoverview: `Our experienced anaesthesiologists deliver 24/7 support with precision monitoring, individualized anaesthesia planning and enhanced recovery protocols for safer surgeries and faster healing.`,
      images: [Anaesthesiologyimage1, Anaesthesiologyimage2],
      diagnosticsMainTitle: "Anaesthesia Services",
      diagnosticsTitle: "Comprehensive Anaesthesia Care",
      diagnostics: [
        "General anaesthesia",
        "Spinal & epidural anaesthesia",
        "Regional anaesthesia",
        "Monitored Anaesthesia Care (MAC)",
        "Sedation for diagnostic & minor procedures",
        "Comprehensive pre-anaesthetic evaluation",
      ],

      proceduresTitle: "Non-Operating Room Anaesthesia (NORA)",
      proceduresDescription: `Safe anaesthesia support for procedures in:`,
      procedures: [
        "Radiology",
        "Endoscopy",
        "Cardiology",
        "Diagnostic & minimally invasive procedures",
      ],
      proceduresNote: `Focused on improving patient comfort, safety and procedural outcomes.`,
      conditionstreatedtitle: "ERAS (Enhanced Recovery After Surgery)",
      conditionstreateddesc: `Our ERAS protocols focus on:`,
      conditionsTreated: [
        "Faster post-surgical recovery",
        "Reduced pain & complications",
        "Early mobilization & rehabilitation",
        "Shorter hospital stay",
        "Improved patient comfort & outcomes",
      ],
      screeningTitle: "Conditions Treated",
      screeningContentList: [
        "Post-operative pain",
        "Cancer-related pain",
        "Back & neck pain",
        "Joint & musculoskeletal pain",
        "Nerve-related (neuropathic) pain",
      ],
      technologiesTitle: "Advanced Pain Relief Approaches",
      technologies: [
        "Medications & pain control therapy",
        "Nerve blocks",
        "Epidural injections",
        "Minimally invasive pain procedures",
        "Long-term chronic pain management",
      ],
      whychoosetitle: "Patient Safety First",
      whychoosepoints: [
        "Continuous Vital Monitoring",
        "Advanced Anaesthesia Delivery Systems",
        "Multidisciplinary Surgical & ICU Support",
        "Customized Anaesthesia Planning for Every Patient",
        "High Standards of Safety & Infection Control",
      ],
      Quotationcontent: `At Prachin Global Hospitals, we combine advanced anaesthesia expertise with effective pain management and enhanced recovery care to ensure safer surgeries, improved comfort and smoother recovery.`,
    },
    doctors: [
      // {
      //   id: 1,
      //   name: "DR ADEEBA ALI ",
      //   dignity: "CONSULTANT RADIOLOGY ",
      //   degree: "MBBS, MD (RADIOLOGY)",
      //   image: Doctor1,
      // },
      // {
      //   id: 2,
      //   name: "DR. SD MOIZ MOHIUDDIN KHAN",
      //   dignity: "CONSULTANT ANESTHESIOLOGIST & CRITICAL CARE INTENSIVIST",
      //   degree: "MBBS, MD (ANASTHESIA), BLS, ACLS PROVIDER (AHA), BCBR",
      //   image: Doctor1,
      // },
      {
        id: 3,
        name: "DR. SD MOIZ MOHIUDDIN KHAN",
        slug: "dr-sd-moiz-mohiuddin-khan",
        dignity: "CONSULTANT ANESTHESIOLOGIST & CRITICAL CARE INTENSIVIST",
        degree: "MBBS, MD (ANASTHESIA), BLS, ACLS PROVIDER (AHA), BCBR",
        image: MOHIUDDIN,
      },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },

  {
    slug: "critical-care",
    title: "Critical Care",
    category: "core",
    icon: CriticalCareIcon,
    banner: bannerCritical,
    banner_m: bannerCritical_m,
        shortdesc:
      "Prachin Global Hospitals offers advanced Critical Care and Intensive Care Unit (ICU) services.",
    sections: {
      overview: `Prachin Global Hospitals offers advanced Critical Care and Intensive Care Unit (ICU) services for life-threatening and complex medical conditions, with 24/7 expert monitoring, rapid response and life-saving interventions.`,

      moreoverview: `Our ICU is designed to meet international standards, ensuring precision care, continuous monitoring and compassionate support when every second matters.`,
      diagnosticsTitle: "Advanced ICU Facilities",
      diagnostics: [
        "Fully Equipped, Continuously Monitored ICU Beds",
        "Advanced Ventilators & Life-Support Systems",
        "Real-Time Vital Parameter Monitoring",
        "Rapid Access to Diagnostics, Imaging & Laboratory Services",
        "Infection-Controlled Critical Care Environment",
      ],

      proceduresTitle: "Expert Critical Care Team",
      procedures: [
        "Critical Care Physicians",
        "ICU-Trained Nurses",
        "Emergency & Trauma Specialists",
        "Multidisciplinary Super-Specialty Support",
      ],
      screeningTitle: "Conditions Managed in ICU",
      screeningContentList: [
        "Severe Infections & Sepsis",
        "Cardiac & Respiratory Failure",
        "Neurological Emergencies",
        "Post-Operative Critical Care",
        "Trauma & Accident-Related Injuries",
        "Multi-Organ Dysfunction",
      ],
      Quotationcontent: `At Prachin Global Hospitals, our Critical Care team delivers continuous expert monitoring and life-saving treatment with precision, speed and compassion to ensure the best possible outcomes.`,
      images: [CriticalCareimage1, CriticalCareimage2],
    },
    doctors: [
      {
        id: 18,
        name: "DR. SD MOIZ MOHIUDDIN KHAN",
        slug: "dr-sd-moiz-mohiuddin-khan",
        dignity: "CONSULTANT ANESTHESIOLOGIST & CRITICAL CARE INTENSIVIST",
        degree: "MBBS, MD (ANASTHESIA), BLS, ACLS PROVIDER (AHA), BCBR",
        image: MOHIUDDIN,
      },
      // {
      //   id: 2,
      //   name: "Dr. Meera Sharma",
      //   dignity: "CTVS Specialist",
      //   degree: "MS, MCh (Cardiothoracic Surgery)",
      //   image: Doctor1,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "emergency-medicine",
    title: "Emergency Medicine",
    icon: emergencyIcon,
    banner: bannerEmergency,
    banner_m: bannerEmergency_m,
        shortdesc:
      "Prachin Global Hospitals provides 24/7 Emergency Medicine & Trauma Care.",
    sections: {
      overview: `Prachin Global Hospitals provides 24/7 Emergency Medicine & Trauma Care with rapid expert response for all medical, surgical and trauma emergencies. Our highly trained emergency physicians, trauma surgeons and critical care teams deliver immediate, coordinated and life-saving treatment with precision, safety and compassion.`,
      diagnosticsMainTitle: "Emergency & Trauma Services",
      diagnosticsTitle: "24/7 Emergency Response",
      diagnostics: [
        "Round-the-Clock Emergency Physicians & Trauma Surgeons",
        "Immediate Triage & Critical Care Stabilization",
        "Golden Hour Emergency Management Protocols",
        "Zero-Delay Emergency Response Systems",
        "Rapid Diagnosis & Life-Saving Interventions",
      ],
      proceduresTitle: "Advanced Trauma Care",
      procedures: [
        "Accident & Polytrauma Management",
        "Cardiac & Medical Emergencies",
        "Stroke & Neurological Emergencies",
        "Surgical Emergencies",
        "Orthopedic Trauma Care",
        "Poisoning & Toxicology Emergencies",
        "Pediatric Emergency Care",
      ],
      screeningTitle: "Advanced Emergency Infrastructure",
      screeningContentList: [
        "Fully Equipped Emergency Operation Theatres",
        "ICU-Backed Emergency & Resuscitation Bays",
        "Ventilator & Advanced Life-Support Systems",
        "Bedside Ultrasound & Emergency Imaging Access",
        "Continuous Patient Monitoring Systems",
        "Rapid Access to Diagnostics & Laboratory Services",
        "24-Hour Pharmacy Support",
      ],
      technologiesTitle: "Ambulance & Rapid Response Support",
      technologies: [
        "24/7 Ambulance Coordination Services",
        "Advanced Life Support (ALS) Ambulance Support",
        "Pre-Arrival Emergency Activation System",
        "Rapid Patient Transfer & Emergency Preparedness",
      ],
      whychoosetitle: "Expert Emergency Team",
      whychoosepoints: [
        "Emergency Medicine Specialists",
        "Trauma Surgeons",
        "Critical Care & ICU Specialists",
        "Multispecialty Surgical Backup (24/7)",
        "Skilled Emergency Nursing & Paramedic Teams",
      ],
      Quotationcontent: `At Prachin Global Hospitals, our Emergency & Trauma Care team is available 24/7 to deliver rapid diagnosis, immediate intervention and life-saving treatment with precision, compassion and excellence.`,
      images: [emergencyimage1, emergencyimage2],
    },
    doctors: [
      {
        id: 17,
        name: "DR. MANDALAPU MOUNIKA",
        slug: "dr-mandalapu-mounika",
        dignity:
          "CONSULTANT EMERGENCY MEDICINE, BLS & ACLS INSTRUCTOR, ATLS PROVIDER",
        degree: "MBBS, MEM, MRCEM",
        image: MOUNIKA,
      },
      // {
      //   id: 2,
      //   name: "DR MANISHANKAR Y",
      //   slug: "dr-manishankar-y",
      //   dignity: "HOD – CONSULTANT EMERGENCY MEDICINE",
      //   degree: "MBBS, MEM, FCCM",
      //   image: MANISHANKAR,
      // },
      // {
      //   id: 3,
      //   name: "Dr. Kiran Kumar",
      //   dignity: "Interventional Cardiologist",
      //   degree: "MD, DNB (Cardiology)",
      //   image: Doctor1,
      // },
      // {
      //   id: 4,
      //   name: "Dr. Sneha Patel",
      //   dignity: "Cardiac Electrophysiologist",
      //   degree: "MD, Fellowship in EP",
      //   image: Doctor1,
      // },
    ],
  },
  {
    slug: "physio-therapy-and-rehabilitation-care",
    title: "Physiotherapy & Rehabilitation Care",
    category: "core",
    icon: PhysioIcon,
    shortdesc:
      "Physiotherapy & Rehabilitation provides advanced recovery and mobility care.",
    banner: bannerPhysio,
    banner_m: bannerPhysio_m,
    sections: {
      overview: `Prachin Global Hospitals offers advanced Physiotherapy and Rehabilitation services focused on restoring movement, reducing pain and improving functional recovery after injury, surgery or chronic musculoskeletal conditions.`,
      moreoverview: `Our expert rehabilitation team provides personalised, goal-oriented recovery programs for patients of all ages.`,
      diagnosticsTitle: "Our Rehabilitation Services",
      diagnostics: [
        "Post-surgical physiotherapy",
        "Sports injury rehabilitation",
        "Joint replacement recovery (Knee, Hip, Shoulder)",
        "Spine & neurological rehabilitation",
        "Pain management therapy",
        "Mobility & gait training",
        "Strengthening & flexibility programs",
      ],

      proceduresTitle: "Advanced Recovery Approach",
      procedures: [
        "Individualised treatment plans",
        "Evidence-based physiotherapy techniques",
        "Advanced rehabilitation equipment",
        "Functional movement training",
        "Long-term joint protection strategies",
      ],
      conditionstreatedtitle: "Sports & Orthopedic Recovery Support",
      conditionstreateddesc: `We support recovery from:`,
      conditionsTreated: [
        "Ligament injuries (ACL, PCL)",
        "Meniscus & cartilage injuries",
        "Fractures & trauma recovery",
        "Arthritis-related mobility issues",
        "Post-arthroscopy & arthroplasty rehabilitation",
      ],
      whychoosetitle: "Why Choose Us",
      whychoosepoints: [
        "Experienced physiotherapists & rehab specialists",
        "Integrated orthopedic & surgical support",
        "Faster, safer recovery programs",
        "Focus on mobility, strength & independence",
        "Patient-centric, personalized care plans",
      ],
      QuotationTitle: `Restore Strength. Regain Movement.`,
      Quotationcontent: `At Prachin Global Hospitals, we combine clinical expertise with advanced rehabilitation science to help patients recover faster and return to an active, pain-free life.`,
      images: [PhysioTherapy1, PhysioTherapy2],
    },
    // doctors: [
    //   {
    //     id: 1,
    //     name: "DR MADHUSUDHAN KOGILA",
    //     dignity: "CONSULTANT PHYSIOTHERAPIST",
    //     degree: "MASTERS IN SPORTS AND MUSCULOSKELETAL REHABILITATION",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 2,
    //     name: "Dr. Meera Sharma",
    //     dignity: "CTVS Specialist",
    //     degree: "MS, MCh (Cardiothoracic Surgery)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 3,
    //     name: "Dr. Kiran Kumar",
    //     dignity: "Interventional Cardiologist",
    //     degree: "MD, DNB (Cardiology)",
    //     image: Doctor1,
    //   },
    //   {
    //     id: 4,
    //     name: "Dr. Sneha Patel",
    //     dignity: "Cardiac Electrophysiologist",
    //     degree: "MD, Fellowship in EP",
    //     image: Doctor1,
    //   },
    // ],
  },
];

export default SPECIALITIES;
